'use client';

import { LocaleSwitcher } from '@northladder/i18n';

import { CloseSVGIcon } from '~/icons';

import { useNavRouter } from '../hooks';

interface IAssessmentHeaderProps {
  /**
   * The current page number of the assessment.
   */
  page?: number;
}

/**
 * -----------------------------------------------------------------------------
 * Renders the top navigation part of the app. (App Logo alone in this case.)
 */
export function AssessmentHeader({ page }: IAssessmentHeaderProps) {
  const { navigateToRoute } = useNavRouter();

  const handleGoHome = () => {
    navigateToRoute('/');
  };

  return (
    <header className="py-4 md:py-8">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <nav className="relative z-50 flex justify-between">
          <div className="flex items-center justify-center gap-2">
            <button aria-label="Home" onClick={handleGoHome} type="button">
              <div>
                <CloseSVGIcon className="text-primary-600 dark:text-primary-400" />
              </div>
            </button>
            {page ? (
              <div
                className="
                  text-primary-600 dark:text-primary-400 text-center text-sm
                  font-normal leading-4 opacity-95
                "
              >
                {page}
                /8
              </div>
            ) : null}
          </div>

          <LocaleSwitcher className="relative !left-0 !right-0 !block !rounded-full" />
        </nav>
      </div>
    </header>
  );
}
